import React from "react";
import { Tabs } from "antd";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { i18, trb } from "@utilities";
import { CountriesSettingsTab } from "./Components/Tabs/CountriesSettingsTab";
import { RisksSettingsTab } from "./Components/Tabs/RisksSettingsTab";
import { NaceBlockersSettingsTab } from "./Components/Tabs/NaceBlockersSettingsTab";

const { TabPane } = Tabs;

const TAB_KEYS = {
  COUNTRIES: "countries",
  RISKS: "risks",
  NACE_BLOCKERS: "NaceBlockers"
};

const TABS = [
  {
    key: TAB_KEYS.COUNTRIES,
    name: i18.ApplicationsLabels.CountrySettings,
    component: <CountriesSettingsTab />
  },
  {
    key: TAB_KEYS.RISKS,
    name: i18.ApplicationsLabels.RiskSettings,
    component: <RisksSettingsTab />
  },
  {
    key: TAB_KEYS.NACE_BLOCKERS,
    name: i18.ApplicationsLabels.NaceBlockersSettings,
    component: <NaceBlockersSettingsTab />
  }
];

export const KycApplicationsSettings = () => {
  const history = useHistory();

  return (
    <div id="card">
      <div className="w-100 page-private-container kyc-application-settings-container">
        <ArrowLeftOutlined onClick={history.goBack} className="icon-primary" />
        <Tabs defaultActiveKey={TAB_KEYS.NACE_BLOCKERS} size="default">
          {TABS.map(({ name, key, component }) => (
            <TabPane tab={trb(name)} key={key}>
              {component}
            </TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};
